import type { SetupTourDefinition } from '../core/types';

export const DASHBOARD_SETUP_TOUR_TARGETS = {
  sidebarDashboardLink: 'dashboard-sidebar-link',
  summary: 'dashboard-summary',
  pickupsTable: 'dashboard-pickups-table',
  tasksTable: 'dashboard-tasks-table',
  dropoffsTable: 'dashboard-dropoffs-table',
  servicesTable: 'dashboard-services-table',
} as const;

export const dashboardSetupTour: SetupTourDefinition = {
  id: 'dashboard_tour',
  label: 'Dashboard Tour',
  onboardingKey: 'dashboard_tour',
  requiresRentalContext: true,
  sidebarTargetsByRoute: {
    '/dashboard': DASHBOARD_SETUP_TOUR_TARGETS.sidebarDashboardLink,
  },
  steps: [
    {
      id: 'sidebar-dashboard',
      route: '/dashboard',
      target: DASHBOARD_SETUP_TOUR_TARGETS.sidebarDashboardLink,
      content: 'Dashboard in the sidebar opens the operational overview.',
      navigateOnEnter: false,
      advanceOnTargetClick: true,
    },
    {
      id: 'summary',
      route: '/dashboard',
      target: DASHBOARD_SETUP_TOUR_TARGETS.summary,
      content:
        "This summary presents today's Pick-ups, Drop-offs, Maintenance, and Tasks at a glance. Fleet Status separates active, other-state, and available vehicles.",
    },
    {
      id: 'pickups',
      route: '/dashboard',
      target: DASHBOARD_SETUP_TOUR_TARGETS.pickupsTable,
      content:
        'The Pick-ups table lists reservations scheduled for vehicle collection on the selected date. The date controls provide access to another day.',
    },
    {
      id: 'tasks',
      route: '/dashboard',
      target: DASHBOARD_SETUP_TOUR_TARGETS.tasksTable,
      content:
        'The Tasks table presents work for the selected date, including completion status and the available add, edit, and delete actions.',
    },
    {
      id: 'dropoffs',
      route: '/dashboard',
      target: DASHBOARD_SETUP_TOUR_TARGETS.dropoffsTable,
      content:
        'The Drop-offs table lists reservations scheduled for vehicle return on the selected date.',
    },
    {
      id: 'services',
      route: '/dashboard',
      target: DASHBOARD_SETUP_TOUR_TARGETS.servicesTable,
      content:
        'The Services table presents vehicle service and maintenance blocks for the selected date, with up to five entries visible at a time.',
      next: {
        label: 'Done',
        completesTour: true,
      },
    },
  ],
};
